import { ComponentPropsWithRef } from "react";

export const PendingIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg viewBox="0 0 12 4" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="12" height="4" rx="0.5" fill="currentColor" />
  </svg>
);
